var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{ref:"resize",staticClass:"mitInput markdown-area p-1",style:(_vm.textareaStyle),domProps:{"value":_vm.markdown},on:{"keyup":_vm.onKey,"blur":_vm.updateAttribute}})}
var staticRenderFns = []

export { render, staticRenderFns }